import * as constants from './constants';
import sagas from './saga';
import * as slice from './slice';

const homeService = { constants, slice, sagas };

export default homeService; 